import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
};
const DefaultColor = "#e6007a";
function WND({
  size = 16,
  color = DefaultColor
}: Props): JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path  d="M15.137 5.76c0-.973-1.383-1.76-3.087-1.76-1.706 0-3.087.787-3.087 1.76 0 .974 1.38 1.765 3.087 1.765 1.704 0 3.087-.79 3.087-1.764m0 13.275c0-.973-1.383-1.76-3.087-1.76-1.706 0-3.087.787-3.087 1.76 0 .974 1.38 1.764 3.087 1.764 1.704 0 3.087-.79 3.087-1.764M7.735 6.458c-.858-.487-2.248.293-3.1 1.742s-.846 3.019.013 3.505c.859.487 2.248-.295 3.098-1.741.853-1.45.848-3.02-.01-3.506m11.714 6.637c-.86-.487-2.246.295-3.099 1.741-.85 1.45-.847 3.02.011 3.506.861.487 2.248-.293 3.1-1.742s.846-3.019-.013-3.505m-11.7 1.741c-.853-1.449-2.242-2.228-3.101-1.741-.859.486-.864 2.056-.01 3.505.85 1.45 2.239 2.229 3.097 1.742s.864-2.056.014-3.506M19.463 8.2c-.853-1.45-2.24-2.229-3.098-1.742-.859.487-.864 2.056-.011 3.503.85 1.45 2.24 2.231 3.098 1.744.859-.486.864-2.056.01-3.505m0 0" /></Svg>;
}
WND.DefaultColor = DefaultColor;
export default WND;